import React from 'react';
import classNames from 'classnames';
import OverflowingText from '../../components/foundations/OverflowingText';
import { KpiDelta } from '../../components/molecules/KpiTile';
import TruncatedNote from './TruncatedNote';
import { METRIC_TONES, TRANSLATION_KEY } from '../constants';
import { breakdownListViewShape } from '../propShapes';
import { buildVerdictDelta, formatVerdictValue } from '../verdictFormat';
import css from './BreakdownList.css';

const TONE_DOT_CLASSES = {
    [METRIC_TONES.GOOD]: css.toneGood,
    [METRIC_TONES.BAD]: css.toneBad,
    [METRIC_TONES.NEUTRAL]: css.toneNeutral,
};

const BreakdownList = ({ view }) => {
    const ListTag = view.ranked ? 'ol' : 'ul';
    return (
        <div className={css.breakdown}>
            <ListTag className={classNames(css.list, view.ranked ? css.ranked : css.unranked)}>
                {view.items.map((item, index) => {
                    const delta = buildVerdictDelta(item.delta, item.tone);
                    return (
                        <li key={`${item.label}-${index}`} className={css.row}>
                            {view.ranked ? (
                                <span className={css.rank}>{index + 1}</span>
                            ) : (
                                <span className={classNames(css.dot, TONE_DOT_CLASSES[item.tone] ?? css.toneNeutral)} />
                            )}
                            <OverflowingText className={css.label}>{item.label}</OverflowingText>
                            <span className={css.valueBlock}>
                                {item.field && <span className={css.fieldLabel}>{item.field}</span>}
                                <span className={css.value}>{formatVerdictValue(item.value, item.display_format)}</span>
                                {delta && <KpiDelta delta={delta} />}
                            </span>
                        </li>
                    );
                })}
            </ListTag>
            <TruncatedNote count={view.truncated_count} translationId={`${TRANSLATION_KEY}.CARD.MORE_RESULTS`} />
        </div>
    );
};

BreakdownList.propTypes = {
    view: breakdownListViewShape.isRequired,
};

export default BreakdownList;
